(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui"), require("cb-components-common"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-analyst-rating", ["element-ui", "cb-components-common", "axios"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-analyst-rating"] = factory(require("element-ui"), require("cb-components-common"), require("axios"));
	else
		root["cb-components-analyst-rating"] = factory(root["ELEMENT"], root["cb-components-common"], root["axios"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_element_ui__, __WEBPACK_EXTERNAL_MODULE_cb_components_common__, __WEBPACK_EXTERNAL_MODULE_axios__) {
return 